// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageContent-module__contentContainer--SKGP5{flex-direction:column;min-width:17.778rem;height:100%;display:flex}.PageContent-module__contentContainer--SKGP5>div{flex-grow:1}.PageContent-module__noScroll--sltFO{overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `PageContent-module__contentContainer--SKGP5`,
	"noScroll": `PageContent-module__noScroll--sltFO`
};
export default ___CSS_LOADER_EXPORT___;
